import { combineReducers } from "redux";
import accounts from "./accountReducer";
import paymentConfirmation from './paymentReducer';
import ui from "./uiReducer";;


const appReducer = combineReducers({
	accounts,
	ui,
	paymentConfirmation
});

const rootReducer = (state, action) => {
	if(action.type === 'RESET_STORE'){
		state = undefined;
	}
	return appReducer(state, action)
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js